import { Snackbar, Alert, CircularProgress, Box, Typography } from "@mui/material";

const NotificationSnackbar = ({
  open,
  message,
  type = "info", // 'success', 'error', 'uploading', 'processing', 'archiving', 'indexed'
  onClose,
  autoHideDuration = 6000,
}) => {
  const getAlertProps = () => {
    switch (type) {
      case "success":
        return {
          severity: "success",
          sx: {
            width: "100%",
            maxWidth: "600px",
            bgcolor: "primary.main",
            color: "white",
            "& .MuiAlert-icon": {
              color: "white",
            },
            "& .MuiAlert-message": {
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
        };
      case "error":
        return {
          severity: "error",
          sx: {
            width: "100%",
            maxWidth: "600px",
            bgcolor: "#d32f2f",
            color: "white",
            "& .MuiAlert-icon": {
              color: "white",
            },
            "& .MuiAlert-message": {
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
        };
      case "uploading":
        return {
          severity: "info",
          sx: {
            width: "100%",
            maxWidth: "600px",
            bgcolor: "primary.main",
            color: "white",
            "& .MuiAlert-icon": {
              display: "none", // Hide default icon for uploading
            },
            "& .MuiAlert-message": {
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              alignItems: "center",
              gap: 1,
            },
          },
        };
      default:
        return {
          severity: "info",
          sx: {
            width: "100%",
            maxWidth: "600px",
            bgcolor: "primary.main",
            color: "white",
            "& .MuiAlert-icon": {
              color: "white",
            },
            "& .MuiAlert-message": {
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
        };
    }
  };

  const renderMessage = () => {
    if (type === "uploading") {
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={16} sx={{ color: "white" }} />
          <Typography variant="body2">{message}</Typography>
        </Box>
      );
    }
    return message;
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={type === "uploading" ? null : autoHideDuration}
      onClose={type === "uploading" ? undefined : onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        top: { xs: 80, sm: 80 }, // Position right under the header
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        "& .MuiSnackbarContent-root": {
          width: "auto",
          minWidth: "300px",
          maxWidth: "600px",
        },
      }}
    >
      <Alert
        onClose={type === "uploading" ? undefined : onClose}
        variant="filled"
        elevation={6}
        {...getAlertProps()}
      >
        {renderMessage()}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;
